module.exports = __webpack_public_path__ + "img/google-logo.c99c1668.svg";